import { render, staticRenderFns } from "./jifentiao.vue?vue&type=template&id=6e4deb1c&scoped=true"
import script from "./jifentiao.vue?vue&type=script&lang=ts"
export * from "./jifentiao.vue?vue&type=script&lang=ts"
import style0 from "./jifentiao.vue?vue&type=style&index=0&id=6e4deb1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4deb1c",
  null
  
)

export default component.exports